import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star } from 'lucide-react';
const reviews = [{
  name: 'Jessica M.',
  location: 'Austin, TX',
  dog: 'Max, Golden Retriever, 9 years old',
  image: 'https://images.unsplash.com/photo-1552053831-71594a27632d?w=400&h=400&fit=crop&crop=face',
  text: "Max had arthritis and could barely climb the stairs. After 3 weeks on the protocol, he's running at the park again! His vet couldn't believe it. This book changed my dog's life.",
  stars: 5
}, {
  name: 'Roberto C.',
  location: 'Miami, FL',
  dog: 'Luna, Labrador, 11 years old',
  image: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400&h=400&fit=crop&crop=face',
  text: 'Luna was losing fur and had zero energy. I started the "Living Toppers" from the protocol and in 21 days her coat was shining like when she was a puppy. Now she plays like she\'s 5 again. Incredible!',
  stars: 5
}, {
  name: 'Sarah T.',
  location: 'Denver, CO',
  dog: 'Buddy, Beagle, 8 years old',
  image: 'https://images.unsplash.com/photo-1543466835-00a7907e9de1?w=400&h=400&fit=crop&crop=face',
  text: 'My vet told me Buddy had kidney issues from tap water. I followed the water detox guide and his levels improved at the next checkup. For $6.36 I saved my best friend.',
  stars: 5
}];
export function ReviewsSection() {
  return <section className="py-20 md:py-28 px-6 bg-surface" data-id="element-145">
      <div className="max-w-7xl mx-auto" data-id="element-146">
        <FadeIn className="text-center mb-16" data-id="element-147">
          <h3 className="uppercase tracking-[0.3em] text-amber text-sm font-semibold mb-4" data-id="element-148">
            TESTIMONIALS
          </h3>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-149">
            Happy Owners, Healthier Dogs
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-150">
          {reviews.map((review, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-151">
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden h-full flex flex-col" data-id="element-152">
                <div className="h-56 overflow-hidden" data-id="element-153">
                  <img src={review.image} alt={review.dog} className="w-full h-full object-cover" data-id="element-154" />
                </div>
                <div className="p-6 flex flex-col flex-1" data-id="element-155">
                  <div className="flex gap-0.5 mb-3" data-id="element-156">
                    {[...Array(review.stars)].map((_, i) => <Star key={i} className="w-4 h-4 text-amber fill-amber" data-id="element-157" />)}
                  </div>
                  <p className="text-body text-sm leading-relaxed mb-4 flex-1" data-id="element-158">
                    "{review.text}"
                  </p>
                  <div className="border-t border-white/10 pt-4 mt-auto" data-id="element-159">
                    <p className="text-white font-semibold text-sm" data-id="element-160">
                      {review.name}
                    </p>
                    <p className="text-muted text-xs" data-id="element-161">{review.location}</p>
                    <p className="text-amber text-xs mt-1" data-id="element-162">🐾 {review.dog}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}